module.exports = __webpack_public_path__ + "static/img/pcbg.080330af.jpg";